"use client";
import React from "react";
import { usePathname } from "next/navigation";
import Link from "next/link";
import { useTranslations } from "next-intl";

import { useTheme } from "@/context/Theme.context";

import Navbar from "../navbar/navbar";
import { Button, ShowWhen } from "@/components/common";
import { BoxetteLogoDark, EasyXpressLogo } from "@/components/assets/icons";

import { Theme } from "@/enums";
import { SwitchLanguage } from "../../header";

const AuthHeader = () => {
  const pathname = usePathname();
  const t = useTranslations();

  const theme = useTheme();

  const showRegistrationBtn =
    pathname.includes("log-in") || pathname.includes("password-recovery");

  return (
    <header className="mb-[3.625rem] flex items-center gap-4">
      <div className="flex w-full items-center gap-6 2xl:gap-10">
        <div className="h-[2.125rem] w-[8.75rem]">
          <ShowWhen
            condition={theme === Theme.GEORGIA || theme === Theme.UZ}
            elseRender={<EasyXpressLogo />}
          >
            <Link href="/log-in">
              <BoxetteLogoDark />
            </Link>
          </ShowWhen>
        </div>
        <Navbar />
      </div>
      <div className="flex items-center gap-4">
        <SwitchLanguage isExternalPage />
        <Link
          className="w-[9.375rem]"
          href={showRegistrationBtn ? "/sign-up" : "/log-in"}
        >
          <Button className="h-[50px] text-lg">
            <ShowWhen condition={showRegistrationBtn} elseRender={t("login")}>
              {t("register")}
            </ShowWhen>
          </Button>
        </Link>
      </div>
    </header>
  );
};

export default AuthHeader;
